/** @jsxImportSource @emotion/react */


import { Heading as RadixThemesHeading, IconButton as RadixThemesIconButton, Select as RadixThemesSelect } from "@radix-ui/themes"
import { ColorModeContext, EventLoopContext, StateContexts } from "$/utils/context"
import { Fragment, useCallback, useContext } from "react"
import { Event, isTrue } from "$/utils/state"
import { Moon as LucideMoon, Sun as LucideSun } from "lucide-react"
import { jsx } from "@emotion/react"




export function Select__content_656c8fe91a0587acf359a6bfaa444665 () {
  
  const reflex___state____state__map___common____demo_state = useContext(StateContexts.reflex___state____state__map___common____demo_state)





  
  return (
    jsx(
RadixThemesSelect.Content,
{},
reflex___state____state__map___common____demo_state.pages.map((page,index_59896a127f0e8d33)=>(jsx(
RadixThemesSelect.Item,
{key:index_59896a127f0e8d33,value:page["route"]},
jsx(
RadixThemesHeading,
{size:"3"},
page["title"]
,),))),)
  )
}

export function Select__root_9891502375e64bdca86a76873639e4de () {
  
  const reflex___state____state = useContext(StateContexts.reflex___state____state)
  const [addEvents, connectErrors] = useContext(EventLoopContext);


  const on_change_da55e2b8dadd35b302dd732d71fd2317 = useCallback(((_ev_0) => (addEvents([(Event("_redirect", ({ ["path"] : _ev_0, ["external"] : false, ["replace"] : false }), ({  })))], [_ev_0], ({  })))), [addEvents, Event])



  
  return (
    jsx(
RadixThemesSelect.Root,
{onValueChange:on_change_da55e2b8dadd35b302dd732d71fd2317,value:((reflex___state____state.router["page"]["path"] === "/") ? "" : reflex___state____state.router["page"]["path"])},
jsx(RadixThemesSelect.Trigger,{placeholder:"Select Demo"},)
,jsx(Select__content_656c8fe91a0587acf359a6bfaa444665,{},)
,)
  )
}

export function Fragment_4735041bcb8d807a384b59168d698006 () {
  
  const { resolvedColorMode } = useContext(ColorModeContext)





  
  return (
    jsx(
Fragment,
{},
((resolvedColorMode === "light") ? (jsx(
Fragment,
{},
jsx(LucideSun,{},)
,)) : (jsx(
Fragment,
{},
jsx(LucideMoon,{},)
,))),)
  )
}

export function Iconbutton_98348b16bede352a0d51b6c9200c6e68 () {
  
  const { toggleColorMode } = useContext(ColorModeContext)
  const [addEvents, connectErrors] = useContext(EventLoopContext);


  const on_click_9922dd3e837b9e087c86a2522c2c93f8 = useCallback(toggleColorMode, [addEvents, Event, toggleColorMode])



  
  return (
    jsx(
RadixThemesIconButton,
{css:({ ["padding"] : "6px", ["background"] : "transparent", ["color"] : "inherit", ["zIndex"] : "20", ["&:hover"] : ({ ["cursor"] : "pointer" }) }),onClick:on_click_9922dd3e837b9e087c86a2522c2c93f8},
jsx(Fragment_4735041bcb8d807a384b59168d698006,{},)
,)
  )
}
